import React from 'react'

import LogisticTopMenu from '@components/logistic/LogisticTopMenu'
import VehiclesList from '@components/logistic/vehicles/VehiclesList'
import VehiclesSubMenu from '@components/logistic/vehicles/VehiclesSubMenu'




export default function VehiclesPages () {
  
  return (
    <div className='VehiclesList'>
      <h1 className='u-heading'>Транспорт</h1>
      <LogisticTopMenu />
      <VehiclesSubMenu />

      <VehiclesList />
    </div>
  )
}